import { paths } from "helpers/paths";
import React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./list";
import Show from "./show";

export default function UniversalTransferDocuments(props) {
    return (
        <Switch location={props.location}>
            <Route exact path={paths.universalTransferDocuments} component={List} />
            <Route path={paths.universalTransferDocumentsShow(":id")} component={Show} />
        </Switch>
    );
}
